import script from "./ReportDetailsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportDetailsChart.vue?vue&type=script&setup=true&lang=js"

import "./ReportDetailsChart.vue?vue&type=style&index=0&id=06916656&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06916656"]])

export default __exports__